import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import BarometreLogo from './BarometreLogo';

export default function PublicHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { isAuthenticated, logout } = useAuth();

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-10 bg-white/90 backdrop-blur-sm border-b border-slate-200"
      aria-label="Navigation principale"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex justify-between items-center">
        <Link
          to="/"
          className="flex items-center gap-2 sm:gap-2.5 min-h-[44px] py-2 rounded-lg text-primary-600 hover:text-primary-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
        >
          <BarometreLogo decorative className="h-9 w-9 sm:h-10 sm:w-10 text-primary-600" />
          <span className="font-bold text-slate-900 text-sm sm:text-base leading-tight">
            Baromètre Social
          </span>
        </Link>

        {/* Bouton menu mobile (visible sur petit écran) */}
        <button
          type="button"
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden min-w-[44px] min-h-[44px] flex items-center justify-center text-slate-600 hover:text-primary-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          aria-expanded={menuOpen}
          aria-controls="main-nav"
          aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>

        {/* Liens desktop (cachés sur mobile) */}
        <div id="main-nav" className="hidden md:flex gap-4 items-center">
          {isAuthenticated ? (
            <>
              <Link
                to="/admin/surveys"
                className="text-slate-600 hover:text-primary-600 text-sm py-2 px-3 min-h-[44px] flex items-center rounded-lg focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
              >
                Mon espace
              </Link>
              <Link
                to="/admin/subscription"
                className="text-slate-600 hover:text-primary-600 text-sm py-2 px-3 min-h-[44px] flex items-center rounded-lg focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
              >
                Mon abonnement
              </Link>
              <button
                type="button"
                onClick={logout}
                className="text-slate-600 hover:text-primary-600 text-sm py-2 px-3 min-h-[44px] flex items-center rounded-lg focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
              >
                Déconnexion
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="text-slate-600 hover:text-primary-600 text-sm py-2 px-3 min-h-[44px] flex items-center rounded-lg focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
              >
                Connexion
              </Link>
              <Link
                to="/register"
                className="text-primary-600 hover:text-primary-700 font-medium text-sm py-2 px-3 min-h-[44px] flex items-center rounded-lg focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
              >
                Inscription
              </Link>
            </>
          )}
          <Link
            to="/pricing"
            className="text-slate-600 hover:text-primary-600 text-sm py-2 px-3 min-h-[44px] flex items-center rounded-lg focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          >
            Tarifs
          </Link>
        </div>
      </div>

      {/* Menu mobile déroulant */}
      {menuOpen && (
        <div className="md:hidden border-t border-slate-200 bg-white px-4 py-4">
          <div className="flex flex-col gap-1">
            {isAuthenticated ? (
              <>
                <Link
                  to="/admin/surveys"
                  className="text-slate-600 hover:text-primary-600 py-3 px-3 min-h-[44px] flex items-center rounded-lg hover:bg-slate-50"
                  onClick={() => setMenuOpen(false)}
                >
                  Mon espace
                </Link>
                <Link
                  to="/admin/subscription"
                  className="text-slate-600 hover:text-primary-600 py-3 px-3 min-h-[44px] flex items-center rounded-lg hover:bg-slate-50"
                  onClick={() => setMenuOpen(false)}
                >
                  Mon abonnement
                </Link>
                <button
                  type="button"
                  onClick={() => { setMenuOpen(false); logout(); }}
                  className="text-left text-slate-600 hover:text-primary-600 py-3 px-3 min-h-[44px] flex items-center rounded-lg hover:bg-slate-50"
                >
                  Déconnexion
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-slate-600 hover:text-primary-600 py-3 px-3 min-h-[44px] flex items-center rounded-lg hover:bg-slate-50"
                  onClick={() => setMenuOpen(false)}
                >
                  Connexion
                </Link>
                <Link
                  to="/register"
                  className="text-primary-600 hover:text-primary-700 font-medium py-3 px-3 min-h-[44px] flex items-center rounded-lg hover:bg-primary-50"
                  onClick={() => setMenuOpen(false)}
                >
                  Inscription
                </Link>
              </>
            )}
            <Link
              to="/pricing"
              className="text-slate-600 hover:text-primary-600 py-3 px-3 min-h-[44px] flex items-center rounded-lg hover:bg-slate-50"
              onClick={() => setMenuOpen(false)}
            >
              Tarifs
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
